export const IconReserve = ({ style, className }) => {
  return (
    <svg
      style={style}
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M29.2917 24V25.3333C29.2917 27.5333 29.2917 29.3333 25.2917 29.3333H6.625C2.625 29.3333 2.625 27.5333 2.625 25.3333V24C2.625 23.2667 3.225 22.6667 3.95833 22.6667H27.9583C28.6917 22.6667 29.2917 23.2667 29.2917 24Z" />
      <path opacity="0.4" d="M27.626 17.3333V22.6667H4.35938V17.3333C4.35938 12.2133 7.97271 7.93333 12.786 6.90667C13.506 6.74667 14.2527 6.66667 15.026 6.66667H16.9594C17.7327 6.66667 18.4927 6.74667 19.2127 6.90667C24.026 7.94667 27.626 12.2133 27.626 17.3333Z" />
      <path d="M19.3346 6C19.3346 6.32 19.2946 6.61333 19.2146 6.90667C18.4946 6.74667 17.7346 6.66667 16.9613 6.66667H15.028C14.2546 6.66667 13.508 6.74667 12.788 6.90667C12.708 6.61333 12.668 6.32 12.668 6C12.668 4.16 14.1613 2.66667 16.0013 2.66667C17.8413 2.66667 19.3346 4.16 19.3346 6Z" />
      <path d="M20 15.6667H12C11.4533 15.6667 11 15.2133 11 14.6667C11 14.12 11.4533 13.6667 12 13.6667H20C20.5467 13.6667 21 14.12 21 14.6667C21 15.2133 20.5467 15.6667 20 15.6667Z" />
    </svg>
  );
};
